export default 'Estimez vos primes CEE en 60 sec : renseignez votre SIRET, répondez à 5 questions, obtenez une fourchette chiffrée et les fiches éligibles. Gratuit, sans inscription.';
